import {View} from "./View"
export const Customers = () => {
    return (
        <View/>
    )
}